import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LocalSetting } from '../common/LocalSetting';

@Component({
    selector: 'app-multi-user-picker',
    templateUrl: './multi-user-picker.component.html',
    styleUrls: ['./multi-user-picker.component.css']
})
export class MultiUserPickerComponent implements OnInit {

    logging = false;
    apiUrl: string;
    errorMsg: string;
    selected = '';
    list: { id: number, name: string }[] = [];

    constructor(private http: HttpClient) {
        this.logging = LocalSetting.getLoggin();
        if (environment.localApi) {
            this.apiUrl = 'assets/user.list.json';
            // this.apiUrl = "assets/user.api.wrong.field.json";
            // this.apiUrl = "assets/user.api.not.array.json";
        } else {
            this.apiUrl = '/jersey2/api/users/range.json?from=1&to=100000';
        }
        if (this.logging) {
            console.log(this.apiUrl);
        }

        this.http.get(this.apiUrl).subscribe((res: any[]) => {
            this.handleApiResonse(res);
        }, (err) => {
            this.errorMsg = `API Error: ${err.status} ${err.statusText}`;
        });
    }

    ngOnInit(): void {
    }

    private handleApiResonse(res: any[]): void {

        if (this.logging) {
            console.log('handle API response...');
        }

        const tempList: { id: number, name: string }[] = [];

        // convert to target option list
        this.errorMsg = '';
        if (!Array.isArray(res)) {
            this.errorMsg = 'Didn\'t find array from API response';
            return;
        }

        res.forEach(item => {
            if (!item.id) {
                this.errorMsg = 'Didn\'t find id from API response';
                return;
            }
            if (!item.name) {
                this.errorMsg = 'Didn\'t find name from API response';
                return;
            }

            const one = {
                id: item.id,
                name: item.name
            };
            tempList.push(one);
        });

        if (this.errorMsg) {
            return;
        }

        this.list = tempList;
        // set selected
    }

    handleChange(x): void {
        const ele = x.srcElement as HTMLSelectElement;

        let selected = '';
        for (let i = 0; i < ele.options.length; i++) {
            const o = ele.options[i];
            if (o.selected) {
                if (selected){
                    selected = selected + '; ' + o.text;
                }else{
                    selected = o.text;
                }
            }
        }
        this.selected = selected;

        // const selectedUserList = ele.options.map(function (o) {
        //     return o.text;
        // }).filter(function (o) {

        //     return o.selected;
        // });
        //console.log(selectedUserList);
    }

}
